/** True when the given employee profile belongs to the logged-in user. */
export function isOwnEmployeeProfile(employeeId) {
    const loggedInId = sessionStorage.getItem("employee_id");
    if (!loggedInId || employeeId == null || employeeId === "") {
        return false;
    }
    return String(employeeId) === String(loggedInId);
}

export const REMARKS_SELF_VIEW_MESSAGE =
    "You cannot add or manage remarks on your own profile. Remarks entered by HR or your manager appear on the Activity tab.";
